import PropTypes from 'prop-types';
import React from 'react';
import DateField from 'components/DateField';
import { Checkbox } from '@ontruck/orc';

const CheckAndDateList = ({
  checkboxClassname,
  fieldList,
  object,
  t,
  handleFieldChange,
  errors = {},
  className = '',
  size = '',
  inputClass = '',
}) => (
  <div>
    {fieldList.map((name) => {
      const checkName = `has_${name}`;
      const checked = object[checkName];

      return (
        <div key={name} className={className}>
          <Checkbox
            className={checkboxClassname}
            name={t[checkName]}
            label={t[checkName]}
            checked={checked}
            onChange={(e, { value }) => {
              handleFieldChange(checkName)(value, () =>
                handleFieldChange(name)(value ? object[name] : null)
              );
            }}
          />
          {checked && (
            <DateField
              label={t[name]}
              inputClass={inputClass}
              value={object[name] || ''}
              onChange={handleFieldChange(name)}
              disabled={!checked}
              error={(checked && errors[name]) || null}
              size={size}
            />
          )}
        </div>
      );
    })}
  </div>
);

CheckAndDateList.propTypes = {
  className: PropTypes.string,
  checkboxClassname: PropTypes.string,
  fieldList: PropTypes.array,
  object: PropTypes.object,
  t: PropTypes.object,
  handleFieldChange: PropTypes.func,
  errors: PropTypes.object,
  size: PropTypes.string,
  inputClass: PropTypes.string,
};

export default CheckAndDateList;
